import { Box, Button, ButtonProps, Typography } from '@material-ui/core'

export default function TooltipTextfield({ title = undefined as any, ...rest }: { title?: any } & Partial<ButtonProps>) {
	return (

		<Box display="flex" gridGap="8px" justifyContent="space-between" alignItems="center">
			<Typography variant="subtitle2">{title}</Typography>
			<Button
				{...rest}
			/>
		</Box>
	)
}
